import { createIcon } from "@chakra-ui/icons";

export const InfoBoxIcon = createIcon({
  displayName: "InfoBoxIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      d="M12.6666 4.85221L6.99998 8.00036M6.99998 8.00036L1.33331 4.85221M6.99998 8.00036L7 14.3337M8.33333 13.9263L7.51802 14.3793C7.32895 14.4843 7.23442 14.5368 7.1343 14.5574C7.0457 14.5756 6.95431 14.5756 6.8657 14.5574C6.76559 14.5368 6.67105 14.4843 6.48198 14.3793L1.54865 11.6385C1.34897 11.5276 1.24912 11.4721 1.17642 11.3932C1.11211 11.3234 1.06343 11.2407 1.03366 11.1506C1 11.0487 1 10.9345 1 10.7061V5.29468C1 5.06625 1 4.95204 1.03366 4.85017C1.06343 4.76005 1.11211 4.67733 1.17642 4.60754C1.24912 4.52865 1.34897 4.47318 1.54865 4.36225L6.48198 1.6215C6.67105 1.51647 6.76559 1.46395 6.8657 1.44336C6.95431 1.42513 7.0457 1.42513 7.1343 1.44336C7.23442 1.46395 7.32895 1.51646 7.51802 1.6215L12.4514 4.36224C12.651 4.47318 12.7509 4.52865 12.8236 4.60754C12.8879 4.67733 12.9366 4.76005 12.9663 4.85017C13 4.95204 13 5.06625 13 5.29468L13 8.33372M4 3.00038L10 6.33371M11.6667 14.0004V10.0004M9.66667 12.0004H13.6667"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
